import { SvgIconProps } from "@mui/material";
import SvgIcon from "@mui/material/SvgIcon";
// eslint-disable-next-line no-restricted-imports
import { CloseSvg } from "../icons/close";

export const IconClose = (props: SvgIconProps) => (
    <SvgIcon {...props} viewBox="0 0 24 24">
        <CloseSvg />
    </SvgIcon>
);
